'use client';

import type { McpServerResponseDto } from '@terra/shared-contracts-mcp-servers';
import { VStack } from '@terra/ui-styled-system';
import { useTranslations } from 'next-intl';
import { McpServersAttachList } from '../../settings/McpServersAttachList';
import { SettingsSection } from '../../settings/SettingsSection';

export type ApplicationMcpServersSectionProps = {
  servers: McpServerResponseDto[];
  attachedServerIds: ReadonlySet<string>;
  hasTenantServers: boolean;
  isLoading: boolean;
  isMutating: boolean;
  onToggle: (input: { server: McpServerResponseDto; checked: boolean }) => void;
};

export function ApplicationMcpServersSection({
  servers,
  attachedServerIds,
  hasTenantServers,
  isLoading,
  isMutating,
  onToggle,
}: ApplicationMcpServersSectionProps) {
  const t = useTranslations('designSystem.applicationSettings.mcpServers');
  const list = (
    <McpServersAttachList
      servers={servers}
      attachedServerIds={attachedServerIds}
      hasTenantServers={hasTenantServers}
      isLoading={isLoading}
      isMutating={isMutating}
      labels={{
        loading: t('loading'),
        emptyTitle: t('empty'),
        emptyDescription: t('emptyDescription'),
        noEligibleTitle: t('noEligible'),
        noEligibleDescription: t('noEligibleDescription'),
        requiresApproval: t('requiresApproval'),
      }}
      onToggle={onToggle}
    />
  );

  if (isLoading || servers.length === 0) {
    return list;
  }

  return (
    <VStack alignItems="stretch" gap={8} w="full">
      <SettingsSection title={t('title')} description={t('description')}>
        {list}
      </SettingsSection>
    </VStack>
  );
}
